import AbstractApi from '@/api/abstracts/AbstractApi'
import EquipmentApi from '@/api/services/sales/bid/spec/paperwork/equipment/EquipmentApi'
import ChannelApi from '@/api/services/sales/bid/spec/paperwork/channel/ChannelApi'
import httpClient from '@/utilities/service/httpClient'
// types
import { PaperworkSaveDetailsType, PaperworkSaveItemType, PaperworkType } from '@/api/types/response/PaperworkType'
import { PaperworkSaveDetailsPayloadType, PaperworkSaveItemPayloadType } from '@/api/types/request/PaperworkSavePayloadType'

/**
 * @property string apiEnd /api/sales/bid/spec/{bidNumber}/{siteId}/paperwork
 */
export default class PaperworkApi extends AbstractApi {
  fetch(): Promise<PaperworkType> {
    return httpClient.get(this.apiEnd)
  }

  equipment(): EquipmentApi {
    return new EquipmentApi(`${this.apiEnd}/equipment`)
  }

  channel(): ChannelApi {
    return new ChannelApi(`${this.apiEnd}/channel`)
  }

  saveItem(payload: PaperworkSaveItemPayloadType): Promise<PaperworkSaveItemType> {
    return httpClient.post(`${this.apiEnd}/item`, payload)
  }

  saveDetails(payload: PaperworkSaveDetailsPayloadType): Promise<PaperworkSaveDetailsType> {
    return httpClient.post(`${this.apiEnd}/details`, payload)
  }
}
